import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Auth.css';
import signinGraphic from '../icons/signin.png';

const Signup: React.FC = () => {
  const [orgName, setOrgName] = useState('');
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { signUp } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!orgName.trim()) {
      setError('Organization name is required');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);
    const { error } = await signUp(email, password, fullName, orgName.trim());
    // Clear passwords from state immediately
    setPassword('');
    setConfirmPassword('');

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      setSuccess(true);
      setLoading(false);
      setTimeout(() => navigate('/login'), 2000);
    }
  };

  return (
    <div className="auth-container-new">
      <div className="auth-left">
        <div className="auth-left-content">
          <h1>Bring your team into one workspace</h1>
          <p>Create your organization, invite the team, and start shipping together.</p>
          <div className="auth-graphic">
            <img src={signinGraphic} alt="Workspace illustration" />
          </div>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-right-content">
          <div className="auth-greeting">
            <h2>Create Organization</h2>
            <p>Set up your workspace and get your team on board.</p>
          </div>

          <div className="auth-buttons-row">
            <Link to="/login" className="switch-btn">
              Already have an account? Login
            </Link>
          </div>

          <div className="auth-divider">Or sign up with email</div>

          <form onSubmit={handleSubmit} className="auth-form-new">
            {error && <div className="error-message">{error}</div>}
            {success && (
              <div className="success-message">
                Organization created! Redirecting to login...
              </div>
            )}

            <input
              type="text"
              value={orgName}
              onChange={(e) => setOrgName(e.target.value)}
              placeholder="Organization Name"
              required
              disabled={loading}
              className="auth-input"
            />

            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              placeholder="Your Full Name"
              required
              disabled={loading}
              className="auth-input"
            />

            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Work Email"
              required
              disabled={loading}
              className="auth-input"
            />

            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              autoComplete="new-password"
              required
              disabled={loading}
              className="auth-input"
            />

            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm Password"
              autoComplete="new-password"
              required
              disabled={loading}
              className="auth-input"
            />

            <button type="submit" className="auth-submit-btn" disabled={loading}>
              {loading ? 'Creating organization...' : 'Create Organization'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Signup;
